import { MCP_URL, type McpClient, type McpPermission } from "@/services/mcp-connection.service";

export const PERMISSION_GROUPS: { label: string; items: { key: McpPermission; label: string }[] }[] = [
	{ label: "Projects", items: [{ key: "projects:read", label: "Read projects, stages & members" }] },
	{
		label: "Tasks",
		items: [
			{ key: "tasks:read", label: "Read tasks" },
			{ key: "tasks:write", label: "Create & update tasks" },
		],
	},
	{
		label: "Tickets",
		items: [
			{ key: "tickets:read", label: "Read tickets" },
			{ key: "tickets:write", label: "Create & update tickets" },
		],
	},
	{
		label: "Comments",
		items: [
			{ key: "comments:read", label: "Read comments" },
			{ key: "comments:write", label: "Post comments" },
		],
	},
];

export const ALL_PERMISSIONS = PERMISSION_GROUPS.flatMap((g) => g.items.map((i) => i.key));
export const READ_PERMISSIONS = ALL_PERMISSIONS.filter((p) => p.endsWith(":read"));

export const CLIENT_LABELS: Record<McpClient, string> = {
	claude: "Claude Code",
	codex: "Codex",
	cursor: "Cursor",
	other: "Claude Desktop / other",
};

export function setupSnippet(client: McpClient, token: string): { hint: string; code: string } {
	switch (client) {
		case "claude":
			return {
				hint: "Run in your terminal:",
				code: `claude mcp add --transport http taskhub ${MCP_URL} \\\n  --header "Authorization: Bearer ${token}"`,
			};
		case "codex":
			return {
				hint: "Add to ~/.codex/config.toml, then export TASKHUB_MCP_TOKEN in your shell:",
				code: `[mcp_servers.taskhub]\nurl = "${MCP_URL}"\nbearer_token_env_var = "TASKHUB_MCP_TOKEN"\n\n# shell\nexport TASKHUB_MCP_TOKEN="${token}"`,
			};
		case "cursor":
			return {
				hint: "Add to ~/.cursor/mcp.json (or .cursor/mcp.json in a project):",
				code: JSON.stringify(
					{ mcpServers: { taskhub: { url: MCP_URL, headers: { Authorization: `Bearer ${token}` } } } },
					null,
					2,
				),
			};
		default:
			return {
				hint: "For stdio-only clients (e.g. Claude Desktop config), bridge with mcp-remote:",
				code: JSON.stringify(
					{
						mcpServers: {
							taskhub: {
								command: "npx",
								args: ["-y", "mcp-remote", MCP_URL, "--header", "Authorization:${TASKHUB_AUTH}"],
								env: { TASKHUB_AUTH: `Bearer ${token}` },
							},
						},
					},
					null,
					2,
				),
			};
	}
}
